import styled from 'styled-components';

export default styled.div`
  
    display: flex;
    position: absolute;
    top: 2rem;
    left: 3rem;
    color: #738A94;
    line-height: 150%;
    background: #ffffff;
    align-items: center;
    max-width: 28rem;
    min-height: 16rem;
    max-height: 50rem;
    border-radius: 0.4rem;
    border: 1px solid #E3E9ED;
    padding: 1rem;
    font-size: 1.2rem;
    z-index: 2;

    @media (min-width: 550px) {
    top: 2.6rem;
  }

`;
